/**
 * Use in switch default value and other type-exhaustive constructs
 * to ensure all type options are covered by reachable code.
 * Displays error in dev to let us know something wrong happened.
 *
 * Postponing by timeout has two benefits:
 * - app actually continues to work so dev machines aren't dead if an error sneaks in
 * - it is not easily catchable - this error should never be, it reveals a type error
 *
 * @example
 * switch (x) {
 *  case '...':
 *    ...
 *    break;
 *  default:
 *    safeAbsurd(x, 'error message for value not defined in switch');
 * }
 */
export function safeAbsurd(_: never, errorMessage?: string): void;
export function safeAbsurd<T>(
  _: never,
  errorMessage: string,
  defaultValue: T,
): T;
export function safeAbsurd<T>(
  _: never,
  errorMessage?: string,
  defaultValue?: T,
): T {
  if (process.env.NODE_ENV === 'development') {
    const e = new Error(errorMessage);
    setTimeout(() => {
      throw e;
    }, 0);
  }
  return defaultValue!;
}
